import { ProductSettlementTaxDto } from './tax.dto';
import { ProductSettlementFinanceDto } from './finance.dto';

export class ProductSettlementDto {
  tax: ProductSettlementTaxDto;
  finance: ProductSettlementFinanceDto;
  settlementTransaction: string;
  productGroup: string;
  productType: string;
  id?: string;

  constructor(d?: ProductSettlementDto) {
    if (!d) {
      return;
    }

    this.tax = d.tax;
    this.finance = new ProductSettlementFinanceDto(d.finance);
    this.settlementTransaction = d.settlementTransaction;
    this.productGroup = d.productGroup;
    this.productType = d.productType;
    this.id = d.id;
  }
}
